import { SortDestinationColorSchema } from "@redotech/redo-fulfillment-wms-common/schema/sort-destination";
import { SortDispositionSchema } from "@redotech/redo-fulfillment-wms-common/schema/sort-disposition";
import { inventoryItemIdFormat } from "@redotech/redo-inventory-id";
import * as z from "zod";

export const getTransferGuidance = {
  name: "getTransferGuidance" as const,
  input: z.object({ inventoryItemId: inventoryItemIdFormat.schema }),
  output: z.object({
    guidance: z
      .object({
        disposition: SortDispositionSchema,
        color: SortDestinationColorSchema,
        merchantName: z.string().nullable(),
      })
      .nullable(),
    currentLocation: z.object({ name: z.string() }).nullable(),
    /** The warehouse still owes work on this unit; it routes to Needs Work. */
    workRequested: z.boolean(),
  }),
};

export type GetTransferGuidanceInput = z.infer<
  typeof getTransferGuidance.input
>;
export type GetTransferGuidanceOutput = z.infer<
  typeof getTransferGuidance.output
>;
